import React from 'react';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { SettingDisplay } from 'lib/SettingDisplay';
import { SwitchFormField } from 'lib/form/fields/SwitchFormField';
import { CreatableChipInputFormField } from 'lib/form/fields/CreatableChipInputFormField';

export const ComtrexSettingsEdit: React.FC<IPointOfSaleSettingsProps> = ({ locationId }) => (
    <>
        {/* Common Only */}
        {locationId === undefined && (
            <>
                <SettingDisplay label="Vendor Name">
                    <TextFormField name="comtrexVendorName" />
                </SettingDisplay>
                <SettingDisplay label="Loyalty At POS Brand Name">
                    <TextFormField name="comtrexLoyaltyAtPosBrandName" />
                </SettingDisplay>
                <SettingDisplay label="Route Traffic Via Proxy">
                    <SwitchFormField name="comtrexProxyEnabled" />
                </SettingDisplay>
            </>
        )}
        {/* Location Only */}
        {locationId !== undefined && (
            <>
                <SettingDisplay label="Host">
                    <TextFormField name="comtrexHost" />
                </SettingDisplay>
                <SettingDisplay label="Payment Type Id">
                    <TextFormField name="comtrexPaymentTypeId" />
                </SettingDisplay>
                <SettingDisplay label="Tip Item Number">
                    <TextFormField name="comtrexTipItemNumber" />
                </SettingDisplay>
                <SettingDisplay label="Note Fire Message ID">
                    <TextFormField name="comtrexNoteFireMessageId" />
                </SettingDisplay>
                <SettingDisplay label="Allergen List Number">
                    <TextFormField name="comtrexAllergenListNumber" />
                </SettingDisplay>
                <SettingDisplay label="Map Allergen As Modifier">
                    <SwitchFormField name="comtrexMapAllergenAsCondiment" />
                </SettingDisplay>
                <SettingDisplay label="Order To Table Sales Type Number">
                    <TextFormField name="comtrexORDER_TO_TABLE_salesTypeNumber" />
                </SettingDisplay>
                <SettingDisplay label="Preorder Sales Type Number">
                    <TextFormField name="comtrexPREORDER_salesTypeNumber" />
                </SettingDisplay>
                <SettingDisplay label="Table Sales Type Number">
                    <TextFormField name="comtrexTABLE_salesTypeNumber" />
                </SettingDisplay>
                <SettingDisplay label="Tab Sales Type Number">
                    <TextFormField name="comtrexTAB_salesTypeNumber" />
                </SettingDisplay>
                <SettingDisplay label="Loyalty At POS Store Id">
                    <TextFormField name="comtrexLoyaltyAtPosStoreId" />
                </SettingDisplay>
                <SettingDisplay label="Loyalty At POS Password">
                    <TextFormField name="comtrexLoyaltyAtPosPassword" />
                </SettingDisplay>
            </>
        )}
        {/* Both */}
        <SettingDisplay label="Filter for Menu Category Ids">
            <CreatableChipInputFormField
                name="comtrexMenuCategoryFilter"
                placeholder=""
                limitTags={4}
                maxInputHeight={100}
            />
        </SettingDisplay>
    </>
);
